import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

const createUserManager = () => {
  const authority =
    process.env.REACT_APP_IDENTITY_AUTHORITY ||
    'https://preprodidentity.accessacloud.com';
  const clientId = process.env.REACT_APP_IDENTITY_CLIENT_ID || '';
  const redirectUri =
    process.env.REACT_APP_IDENTITY_REDIRECT_URI ||
    `${window.location.origin}/auth/callback`;
  const silentRedirectUri =
    process.env.REACT_APP_IDENTITY_SILENT_REDIRECT_URI ||
    `${window.location.origin}/auth/silent-redirect`;
  const postLogoutRedirectUri =
    process.env.REACT_APP_IDENTITY_POST_LOGOUT_REDIRECT_URI ||
    `${window.location.origin}/`;
  const scope =
    process.env.REACT_APP_IDENTITY_SCOPE || 'openid profile email policy';
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  return new UserManager({
    authority,
    client_id: clientId,
    redirect_uri: redirectUri,
    silent_redirect_uri: silentRedirectUri,
    post_logout_redirect_uri: postLogoutRedirectUri,
    response_type: 'code',
    scope,
    automaticSilentRenew: true,
    monitorSession: !isSafari, // Disable for Safari
    loadUserInfo: true,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  });
};

export const userManager = createUserManager();
